import { AuthGuard, CrudOp, templateAuthScope } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const TemplateView: FC = () => {
  const brand = useRequiredProjectParam("brand");
  const templateId = useRequiredSubprojectParam("template");
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  return (
    <AuthGuard authScope={templateAuthScope} crudOp={CrudOp.READ} brand={brand}>
      <Suspense><LazyTemplateView brand={brand} templateId={templateId} projectId={projectId} subprojectId={subprojectId}/></Suspense>
    </AuthGuard>
  );
};

const LazyTemplateView = lazy(importView(
  () => import("../components/TemplateView"),
  (it) => it.TemplateView,
));
